/**
 * @generated SignedSource<<6b28b0aa69fb6d51a9a2519a0de4c49b>>
 * @relayHash 7cc24fa9f03ed3be4e651b3be114259d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3420e8047d0cb6fa23e107140e5f5b3ad217e3e0cea795fef3fb0a8e4dde860c

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraPublishBoardViewConfigInput = {
  settings?: JiraBoardViewSettings | null | undefined;
  viewId: string;
};
export type JiraBoardViewSettings = {
  filterJql?: string | null | undefined;
  groupBy?: string | null | undefined;
};
export type SaveResetViewSettingsPublishSettingsMutation$variables = {
  input: JiraPublishBoardViewConfigInput;
  settingsOpen: boolean;
};
export type SaveResetViewSettingsPublishSettingsMutation$data = {
  readonly jira_publishBoardViewConfig: {
    readonly boardView: {
      readonly " $fragmentSpreads": FragmentRefs<"BoardHeader_view" | "CardOptionSettings" | "RemoveResolvedItems" | "SaveResetViewSettings_view">;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type SaveResetViewSettingsPublishSettingsMutation = {
  response: SaveResetViewSettingsPublishSettingsMutation$data;
  variables: SaveResetViewSettingsPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "settingsOpen"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = [
  (v7/*: any*/),
  {
    "kind": "ScalarField",
    "name": "fieldName"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveResetViewSettingsPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishBoardViewConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishBoardViewConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JiraBoardView",
            "kind": "LinkedField",
            "name": "boardView",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "SaveResetViewSettings_view"
              },
              {
                "kind": "FragmentSpread",
                "name": "BoardHeader_view"
              },
              {
                "condition": "settingsOpen",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "RemoveResolvedItems"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "CardOptionSettings"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveResetViewSettingsPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishBoardViewConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishBoardViewConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JiraBoardView",
            "kind": "LinkedField",
            "name": "boardView",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canPublishViewConfig"
              },
              {
                "kind": "ScalarField",
                "name": "isViewConfigModified"
              },
              {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByOptions",
                "plural": true,
                "selections": (v8/*: any*/)
              },
              {
                "condition": "settingsOpen",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "completedIssueSearchCutOffInDays"
                  },
                  {
                    "alias": "menuCardOptions",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 200
                      }
                    ],
                    "concreteType": "JiraBoardViewCardOptionConnection",
                    "kind": "LinkedField",
                    "name": "cardOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraBoardViewCardOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "name"
                                      },
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "typeKey"
                                      },
                                      (v6/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canToggle"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "enabled"
                                  }
                                ],
                                "type": "JiraBoardViewFieldCardOption"
                              },
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "cardOptions(first:200)"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3420e8047d0cb6fa23e107140e5f5b3ad217e3e0cea795fef3fb0a8e4dde860c",
    "metadata": {},
    "name": "SaveResetViewSettingsPublishSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "506205a519d92084ecc95ac396e81f60";

export default node;
